import React, { useState } from 'react';
import api from '../services/api';
import { MessageSquare, Send, Check } from 'lucide-react';
import { toast } from 'sonner';

export default function Suggestions() {
  const [texto, setTexto] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!texto.trim() || texto.trim().length < 10) {
      toast.error('Escreva uma sugestão com pelo menos 10 caracteres');
      return;
    }
    setSending(true);
    try {
      await api.post('/suggestions/', { texto });
      setSent(true);
      setTexto('');
      toast.success('Sugestão enviada! Obrigado pelo feedback.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao enviar sugestão');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto space-y-6 animate-fade-in py-4">
      <div className="text-center space-y-2">
        <div className="w-14 h-14 bg-orange-500/20 rounded-2xl flex items-center justify-center mx-auto">
          <MessageSquare size={26} className="text-orange-400" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-white">Sugestões</h1>
        <p className="text-zinc-400 text-sm">
          Sua opinião é muito importante! Envie ideias, melhorias ou problemas que encontrou.
        </p>
      </div>

      {sent ? (
        <div className="bg-green-500/10 border border-green-500/30 rounded-2xl p-8 text-center space-y-3">
          <div className="w-14 h-14 bg-green-500/20 rounded-full flex items-center justify-center mx-auto">
            <Check size={26} className="text-green-400" />
          </div>
          <h2 className="font-heading font-bold text-xl text-white">Sugestão enviada!</h2>
          <p className="text-zinc-400 text-sm">Obrigado pelo seu feedback. Vamos analisar e melhorar o sistema.</p>
          <button
            onClick={() => setSent(false)}
            className="mt-2 text-sm text-orange-400 hover:text-orange-300 border border-orange-500/30 hover:bg-orange-500/10 px-4 py-2 rounded-xl transition-colors"
          >
            Enviar outra sugestão
          </button>
        </div>
      ) : (
        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 space-y-4">
          <div>
            <label className="field-label">Sua sugestão ou feedback</label>
            <textarea
              data-testid="suggestion-input"
              className="field-input min-h-[160px] resize-y"
              rows={6}
              placeholder="Descreva sua ideia, melhoria que gostaria de ver, ou um problema que encontrou no sistema..."
              value={texto}
              onChange={e => setTexto(e.target.value)}
            />
            <div className="text-right text-xs text-zinc-600 mt-1">{texto.length} caracteres</div>
          </div>
          <button
            data-testid="send-suggestion-btn"
            onClick={submit}
            disabled={sending || texto.trim().length < 10}
            className="w-full flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white font-bold py-3 rounded-xl transition-colors"
          >
            <Send size={16} />
            {sending ? 'Enviando...' : 'Enviar sugestão'}
          </button>
        </div>
      )}
    </div>
  );
}
